import { RegionShared } from "@1games-ru/region-shared";
import { Position } from "@1games-ru/region-shared/dist/types/world/world";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

// TODO: replace with proper TeleportByCoordsResponse type when region-shared is updated
type TeleportByCoordsResponse = unknown;

export default class AdminMpProvider {
  public static async teleportByCoords(
    position: Position,
  ): Promise<RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<TeleportByCoordsResponse>> {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.TeleportByCoordsRequest,
      TeleportByCoordsResponse
    >("TeleportByCoords", position);
  }
}
